import { render, staticRenderFns } from "./bgView.vue?vue&type=template&id=159d4de4&scoped=true"
import script from "./bgView.vue?vue&type=script&lang=js"
export * from "./bgView.vue?vue&type=script&lang=js"
import style0 from "./bgView.vue?vue&type=style&index=0&id=159d4de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159d4de4",
  null
  
)

export default component.exports